// extracted by mini-css-extract-plugin
module.exports = {"cell":"StyledTableCell_cell__gnBTg","primary":"StyledTableCell_primary__XlvWB"};